/**
 * Interface for the name fields used by the formatter
 * This allows the formatter to work with any person-like data structure
 * (Beneficiary, GroupMember, FamilyMember, etc.)
 */
export interface PersonNameData {
  title?: string;
  firstName?: string;
  middleName?: string;
  lastName?: string;
  suffix?: string;
}

/**
 * Formats name fields into a complete, readable name string
 * Format: Title FirstName MiddleName LastName Suffix
 *
 * The "N/A" suffix placeholder used by the person forms is omitted.
 *
 * @param person - The object holding the name fields
 * @returns Formatted full name string
 */
export const formatFullName = (
  person: PersonNameData | null | undefined
): string => {
  if (!person) {
    return '';
  }

  const name: (string | undefined)[] = [
    person.title,
    person.firstName,
    person.middleName,
    person.lastName
  ];

  if (person.suffix && person.suffix !== 'N/A') {
    name.push(person.suffix);
  }

  return name.filter(Boolean).join(' ');
};
